__turbopack_context__.v({
  "DownloadProductChooserModal--Expanded": "_74og8W_DownloadProductChooserModal--Expanded",
  "DownloadProductChooserModal__Description": "_74og8W_DownloadProductChooserModal__Description",
  "DownloadProductChooserModal__Description--Bold": "_74og8W_DownloadProductChooserModal__Description--Bold",
  "DownloadProductChooserModal__Help": "_74og8W_DownloadProductChooserModal__Help",
  "DownloadProductChooserModal__Icon": "_74og8W_DownloadProductChooserModal__Icon",
  "DownloadProductChooserModal__LegacyButton": "_74og8W_DownloadProductChooserModal__LegacyButton",
  "DownloadProductChooserModal__LegacyChevron": "_74og8W_DownloadProductChooserModal__LegacyChevron",
  "DownloadProductChooserModal__LegacyListItem": "_74og8W_DownloadProductChooserModal__LegacyListItem",
  "DownloadProductChooserModal__Link": "_74og8W_DownloadProductChooserModal__Link",
  "DownloadProductChooserModal__List": "_74og8W_DownloadProductChooserModal__List",
  "DownloadProductChooserModal__ListItem": "_74og8W_DownloadProductChooserModal__ListItem",
  "DownloadProductChooserModal__ListItem--Secondary": "_74og8W_DownloadProductChooserModal__ListItem--Secondary",
  "DownloadProductChooserModal__ListWrapper": "_74og8W_DownloadProductChooserModal__ListWrapper",
  "DownloadProductChooserModal__Loading": "_74og8W_DownloadProductChooserModal__Loading",
  "DownloadProductChooserModal__LoadingLoader": "_74og8W_DownloadProductChooserModal__LoadingLoader",
  "DownloadProductChooserModal__LoadingText": "_74og8W_DownloadProductChooserModal__LoadingText",
  "DownloadProductChooserModal__Sounds": "_74og8W_DownloadProductChooserModal__Sounds",
  "DownloadProductChooserModal__Title": "_74og8W_DownloadProductChooserModal__Title",
});
